module.exports = __webpack_public_path__ + "img/circle1green.28e35c06.png";